/**
 * 表单渲染默认配置
 */
export const formRender = {
  base: {
    labelWidth: 110,
    labelPosition: 'right'
  },
  input: {
    labelPosition: 'right',
    type: 'text'
  },
  maxItemsPerRow: 4,
  blockItemTypes: ['richText', 'divider'],
  notFormItemTypes: ['divider', 'link']
};
